"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AvroError extends Error {
}
exports.default = AvroError;
//# sourceMappingURL=AvroError.js.map